module.exports = __webpack_public_path__ + "img/pay-tb.0c7468e0.png";